import { gql } from '@apollo/client';
const UPDATE_COMPONENT_CONSUMPTIONS = gql `
  mutation UpdateComponentConsumptions($componentsConsumption: [[ID]]!) {
    updateComponentConsumptions(componentsConsumption: $componentsConsumption) {
      component {
        id
        isConsumptionSet
        modelSpecification {
          id
          estimatedCostCalculationBlocked
          confirmationProblems {
            id
            problemType
            blocksEstimatedCostCalculation
            blocksSpecificationConfirmation
            components {
              id
              nodeId
              nodeName
            }
            componentVariants {
              id
              nodeId
              nodeName
            }
          }
          estimatedCostCalculationProblems {
            id
            problemType
            blocksEstimatedCostCalculation
            blocksSpecificationConfirmation
            components {
              id
              nodeId
              nodeName
            }
            componentVariants {
              id
              nodeId
              nodeName
            }
          }
        }
        consumptions {
          edges {
            node {
              id
              consumption
              modelSpecificationSize {
                id
                sizeName {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default UPDATE_COMPONENT_CONSUMPTIONS;
